import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiCategoriesGet } from '@/entities/categories/modules/api/categories';

export const useCategories = () =>
  useFetch({
    api: apiCategoriesGet,
    keywords: queryKeys.categories.all,
    staleTime: 10 * 60 * 1000,
  });
